(function(win, $) {
  'use strict';
  var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
    common = (fp.common = typeof fp.common !== 'undefined' ? fp.common : {});

  fp.common = (function() {
    var getAncestorNode = function(el, className) {
      var i = 0;
      while (i++ < 10) {
        var parentEl = el.parentElement;
        if (!parentEl) {
          return null;
        }
        if (parentEl.classList.contains(className)) {
          return parentEl;
        }
        el = parentEl;
      }
      return null;
    };

    var initNavigation = function() {
      var greaterThanMDscreen = function() {
        return $('#width-detection').css('float') === 'left';
      };

      var closeOpenMenus = function(navEl) {
        if (!greaterThanMDscreen() || document.body.classList.contains('hamburger-nav')) {
          return;
        }
        var topLevel = navEl.querySelectorAll('.top-level-link.open');
        for (var i = 0; i < topLevel.length; ++i) {
          topLevel[i].classList.remove('open');
        }
        var secondary = navEl.querySelectorAll('.secondary.expanded');
        for (i = 0; i < secondary.length; ++i) {
          secondary[i].classList.remove('expanded');
        }
      };

      // Primary Navigation
      var navEls = document.getElementsByTagName('nav');
      Array.prototype.slice.apply(navEls).forEach(function(navEl) {
        navEl.addEventListener('mouseover', function(e) {
          closeOpenMenus(navEl);
        });

        navEl.addEventListener('click', function(e) {
          var tgt = e.target;
          if (tgt.nodeName.toLowerCase() === 'svg' || tgt.nodeName.toLowerCase() === 'rect') {
            tgt = getAncestorNode(tgt, 'top-level-link');
          }

          if (!tgt || !tgt.classList.contains('top-level-link')) {
            return;
          }
          // In a vertical nav like Amphora & Full course they should be able to click top level links
          // unless they are on mobile
          if (tgt.classList.contains('vertical-nav') && greaterThanMDscreen()) {
            return;
          }

          e.preventDefault();
          if (tgt.classList.contains('open')) {
            tgt.classList.remove('open');
            tgt.setAttribute('aria-expanded', false);

            $(tgt)
              .siblings('.secondary')
              .removeClass('expanded');
          } else {
            closeOpenMenus(navEl);

            tgt.classList.add('open');
            tgt.setAttribute('aria-expanded', true);

            $(tgt)
              .siblings('.secondary')
              .addClass('expanded');
          }
        });
      });
    };

    var showValidationBlock = function(errors) {
      var validationBlockEl = document.querySelector('.validation-summary-valid, .validation-summary-errors');
      if (!validationBlockEl) {
        return;
      }

      // Clear existing errors from the list
      var listEl = validationBlockEl.getElementsByTagName('ul')[0];
      while (listEl.firstChild) {
        listEl.removeChild(listEl.firstChild);
      }

      // If there are no errors then set it to valid, which hides it
      if (errors.length === 0) {
        validationBlockEl.classList.remove('validation-summary-errors');
        validationBlockEl.classList.add('validation-summary-valid');
        return;
      }

      // If there are errors then append them to the block and show it
      for (var i = 0; i < errors.length; i++) {
        var errorEl = document.createElement('li');
        errorEl.innerText = errors[i].message;
        listEl.appendChild(errorEl);
      }

      validationBlockEl.classList.remove('validation-summary-valid');
      validationBlockEl.classList.add('validation-summary-errors');
      //validationBlockEl.scrollIntoView({ behavior: 'smooth' });
      var formScrollTarget = document.getElementById('form-scroll-target');
      formScrollTarget.scrollIntoView({ behavior: 'smooth' });
    };

    var handleSpecialMessage = function() {
      // Special message.
      var $specialMessage = $('#special-message');

      if ($specialMessage) {
        var now = new Date();

        var showMessage = win.sessionStorage.getItem('hideSpecialMessage') !== 'true';

        // Check the start date.
        if (showMessage) {
          var startDateString = $specialMessage.data('start-date');
          if (startDateString !== '') {
            var startDate = new Date(startDateString);
            showMessage = now > startDate;
          }

          // Check the end date.
          var endDateString = $specialMessage.data('end-date');
          if (endDateString !== '') {
            var endDate = new Date(endDateString);
            showMessage = now < endDate;
          }

          if (showMessage) {
            //Edited by Corey on 11/2/18
            //$specialMessage.delay(1000).slideDown();
            $specialMessage.css('display', 'block');
          }

          // Handle close button.
          $('#close-special-message').click(function() {
            win.sessionStorage.setItem('hideSpecialMessage', 'true');
            $specialMessage.slideUp();
            return false;
          });

          // Set cookie on link
          $('#special-message-link').click(function() {
            win.sessionStorage.setItem('hideSpecialMessage', 'true');
          });
        }
      }
    };

    return {
      init: function() {
        // Detect if JS is disabled (used in place of Modernizr)
        // If true, the "no-js" on the HTML tag will remain
        $('html').removeClass('no-js');

        $(window).resize(function() {
          if ($('#width-detection').css('float') === 'left') {
            // left === greater than screen-md
            // right === greater than screen-sm
            // none === less than screen-sm

            $('.dropdown .secondary').removeAttr('style');
            $('.top-level-link').removeClass('open');
            $('.nav-for-small-screen').removeAttr('style');
          }
        });

        initNavigation();
        handleSpecialMessage();

        // begin auto scroll

        $('.top-link').click(function() {
            var elementClicked = $(this).attr('href');
            var target = $(elementClicked).offset().top;
            $('html:not(:animated),body:not(:animated)').animate({ scrollTop: target - 0 }, 1000);
            // Added the following for ADA compliance (CM-7/21/19)
            target.focus(); // Setting focus
            if (target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                target.focus(); // Setting focus
            };
            return false;
        });
2
        $('.page-jump').change(function() {
          if ($(this).val() != '') {
            $('#page-jump-form')
              .attr('action', $(this).val())
              .submit();
          }
        });

        // Responsive videos
        $('.video-container').fitVids();
      },

      initPullMenu: function() {
        var $pull = $('#js-mobile-nav-button.slide-down');
        var $menu = $('.nav-for-small-screen');
        var $body = $('body');

        $pull.on('click', function() {
          $menu.slideToggle();
          if ($body.hasClass('nav-open')) {
            $body.removeClass('nav-open');
            this.setAttribute('aria-expanded', 'false');
          } else {
            $body.addClass('nav-open');
            this.setAttribute('aria-expanded', 'true');
          }
        });
      },

      genericHookupForm: function() {
        $('.general-contact-form').submit(function(e) {
          e.preventDefault();
          $('.general-contact-form input.button').attr('value', 'Sending...');

          var $form = $(e.target);
          var url = $form.attr('action');

          var data = $form.serializeArray();
          // Form version 2 will do a full page redirect on success instead of injecting the message
          data.push({ name: 'apiVersion', value: 2 });

          $.ajax({
            url: url,
            data: data,
            method: 'POST'
          })
            .then(function(resp) {
              if (resp.success) {
                var formScrollTarget = document.getElementById('form-scroll-target');
                formScrollTarget.scrollIntoView({ behavior: 'smooth' });
                document.title = resp.pageTitle;

                var thankYouHeading = document.createElement('h2');
                thankYouHeading.innerText = resp.pageHeading;
                var successMsg = document.createElement('p');
                successMsg.innerHTML = resp.message;

                var formEl = document.getElementById('general-form-wrapper');
                formEl.innerHTML = '';
                formEl.appendChild(thankYouHeading);
                formEl.appendChild(successMsg);
              } else {
                var errorEls = document.querySelectorAll('.field-validation-error');
                for (var j = 0; j < errorEls.length; j++) {
                  errorEls[j].classList.add('hidden');
                }

                for (var i = 0; i < resp.errors.length; i++) {
                  var err = resp.errors[i];
                  var field = document.getElementById(err.fieldName);
                  if (!field) {
                    continue;
                  }

                  // show errors from the server
                  var errMsgEl = field.parentNode.querySelector('.field-validation-error, .field-validation-valid');
                  if (!errMsgEl) {
                    errMsgEl = document.createElement('span');
                    field.parentNode.append(errMsgEl);
                  } else {
                    errMsgEl.classList.remove('hidden', 'field-validation-valid');
                  }
                  errMsgEl.classList.add('field-validation-error');
                  errMsgEl.innerText = err.message;
                }
                showValidationBlock(resp.errors);
                $('.general-contact-form input.button').attr('value', 'Send');
              }
            })
            .fail(function(err) {
              $('.general-contact-form input.button').attr('value', 'Send');
              var errorEl = document.createElement('p');
              errorEl.classList.add('error-message');
              errorEl.innerText =
                'Sorry, but there was an error sending your message.  Please try again or contact us by phone.';

              document.getElementById('general-form-wrapper').prepend(errorEl);
            });
        });
      },

      showInstagramPhotos: function(token, openInNewWindow, invalidTokenUrl) {
        $.get('https://api.instagram.com/v1/users/self/media/recent?count=7&access_token=' + token)
          .done(function (resp) {
            var photosContainer = document.querySelector('.feed-wrapper');
            var igLinkEl = document.querySelector('.instagram-link');

            resp.data.forEach(function (img) {
              var photoWrapperEl = document.createElement('div');
              photoWrapperEl.className = 'instagram-photo';

              var linkEl = document.createElement('a');
              linkEl.href = img.link;
              if (openInNewWindow) {
                linkEl.target = 'instagram';
              }

              var spanEl = document.createElement('span');
              spanEl.setAttribute('aria-hidden', true);
              spanEl.className = 'icon icon-instagram';
              var srSpanEl = document.createElement('span');
              srSpanEl.className = 'sr-only';
              srSpanEl.innerText = 'View on Instagram';

              // Thumb=150x150 Low res=320x320, standard res=640x640
              var imgEl = document.createElement('img');
              if ('sizes' in imgEl) {
                imgEl.srcset = img.images.thumbnail.url + ' 150w,' +
                  img.images.low_resolution.url + ' 320w,' +
                  img.images.standard_resolution.url + ' 640w';
                // We are planning to be 4 wide so this is 4x the width + padding
                imgEl.sizes = '(max-width: 600px) 150px,' + 
                  '(max-width: 1280px) 320px,' + 
                  '640px,';
              }
              imgEl.src = img.images.standard_resolution.url;
              imgEl.alt = img.caption ? img.caption.text : '';

              linkEl.appendChild(spanEl);
              linkEl.appendChild(srSpanEl);
              linkEl.appendChild(imgEl);
              photoWrapperEl.appendChild(linkEl);

              photosContainer.insertBefore(photoWrapperEl, igLinkEl);
            })
          })
          .fail(function (err) {
            // If we have an auth exception then lets call our endpoint to send an email to the site owner
            if (err.status === 400 && err.responseJSON.meta && err.responseJSON.meta.error_type === 'OAuthAccessTokenException') {
              fetch(invalidTokenUrl, {
                method: 'POST',
                mode: 'cors'
              });
              return;
            }
          });
      }
    };
  })();
})(window, $);
